import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/email-templates')({
  staticData: { title: 'Email templates' },
})
